import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AssistanceProvided, ContactTypes, ExtensionActivity, ExtensionActivityType} from '../../../../functions/src/types';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {UserService} from '../../services/user.service';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {DataService, ResolveCategory} from "../../services/data.service";
import {ReplaySubject, Subscription} from "rxjs";
import invert from "invert-color";
import {RSDialogService} from "../../../libs/rsnotify/rsdialog.service";
import * as moment from 'moment';
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-assistance',
  templateUrl: './add-assistance.component.html',
  styleUrls: ['./add-assistance.component.scss']
})
export class AddAssistanceComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('form') inputForm: RSValidatorFormDirective;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  assistance: AssistanceProvided = {} as AssistanceProvided;

  activitySub: Subscription;
  activityTypes: ExtensionActivityTypeDisplay[] = [];
  selectActivity: ExtensionActivityTypeDisplay;
  filteredActivities: ReplaySubject<ExtensionActivityTypeDisplay[]> = new ReplaySubject<ExtensionActivityTypeDisplay[]>(1);
  activitySearch = '';
  private risksSubject = new ReplaySubject<any[]>(1);
  filteredRisks = this.risksSubject.asObservable();


  constructor(
    private userService: UserService,
    public dataService: DataService,
    public rsDialogService: RSDialogService,
    private resolveCategory: ResolveCategory) {
    super();
    this.activitySub = this.dataService.activityTypes.subscribe(v => {
      this.activityTypes = v.map(a => {
        const category = this.resolveCategory.transform(a.category);
        return {
          ...a,
          categoryName: category?.name,
          categoryColor: category?.color,
          categoryIcon: category?.icon,
        } as ExtensionActivityTypeDisplay;
      });
    });
  }

  ngOnInit(): void {
    this.dataService.riskAddressedTypes.subscribe(risks => {
      this.risksSubject.next(risks);
    });

    this.updateAssistanceInfo(this.dialogValues?.assistance || {});
    this.dialogValuesUpdated.subscribe(v => this.updateAssistanceInfo(v?.assistance || {}));

  }

  updateAssistanceInfo(input: any) {
    this.assistance = {
      id: input.id || null,
      date: typeof input.date === 'number' ? moment(input.date, 'X').toDate() : new Date(),
      type: input.type,
      user: input.user || this.userService.activeUserId,
      property: input.property || '',
      activities: input.activities || {},
      notes: input.notes || '',
      flagged: input.flagged === true || input.flagged === 'true' || false,
      riskAddressed: input.riskAddressed || '',
      planActivity: input.planActivity || '',
      learntNewSkills: input.learntNewSkills === true || input.learntNewSkills === 'true' || false,
      intentToChange: input.intentToChange === true || input.intentToChange === 'true' || false,
      practiceChange: input.practiceChange === true || input.practiceChange === 'true' || false,
      grantAppliedFor: input.grantAppliedFor === true || input.grantAppliedFor === 'true' || false,
      grantAppliedForName: input.grantAppliedForName || '',
      referralForAdditionalSupport: input.referralForAdditionalSupport || '',
    } as AssistanceProvided;

    if (this.assistance.type) {
      this.onAssistanceTypeChange(this.assistance.type);
    }

  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  activityById(activityId: string) {
    return this.activityTypes.find(at => at.id === activityId);
  }

  private _activitiesByCategoriesFor = null;
  private _activitiesByCategories: {key: string, type: ExtensionActivityTypeDisplay}[] = [];
  activitiesByCategories() {
    const items = Object.keys(this.assistance.activities).join(',');
    if (this._activitiesByCategoriesFor !== items) {
      this._activitiesByCategories = Object.keys(this.assistance.activities).map(v => {
        return {
          key: v,
          type: this.activityById(v)
        };
      })
        .sort(((a, b) => a.type.category.localeCompare(b.type.category)));
      this._activitiesByCategoriesFor = items;
    }
    return this._activitiesByCategories;
  }

  filterActivities(typeId: any) {
    let assistanceType : any;
    if (typeId) {
      assistanceType = this.dataService.assistanceProvidedTypes.getValue()
        .find(type => type.id === typeId);
    }

    // get the search keyword
    let search = this.activitySearch;
    if (!search) {
      this.filteredActivities.next(this.activityTypes.filter(activity =>  assistanceType ?  activity.category === assistanceType.category : true));
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivities.next(
      this.activityTypes.filter(
        activity => activity.name.toLowerCase().indexOf(search) > -1
          && (assistanceType ? activity.category === assistanceType.category : true)
      )
    );
  }

  addActivity(selectedActivity: ExtensionActivityTypeDisplay) {
    console.log('addActivity::: ', selectedActivity);
    if (!this.assistance.activities) {
      this.assistance.activities = {};
    }
    this.assistance.activities[selectedActivity.id] = 1;
  }

  async addToActivity(activityId, value) {
    this.assistance.activities[activityId] += value;
    if (this.assistance.activities[activityId] === 0) {
      const bRemove = await this.rsDialogService.showConfirmDialog(
        'Do you want to remove this activity type?', false, 'Remove', RSDialog.Style.ERROR);
      if (bRemove) {
        delete this.assistance.activities[activityId];
      } else {
        this.assistance.activities[activityId]++;
      }
    }
  }

  onAssistanceTypeChange(typeId: string) {
    const risks = this.dataService.riskAddressedTypes.getValue();
    const filteredRisks = this.filterRisks(risks, typeId);
    this.filterActivities(typeId);
    this.risksSubject.next(filteredRisks);
  }

  private filterRisks(risks: any[], typeId: string) {
    if (!typeId) {
      return risks;
    }

    const assistanceType = this.dataService.assistanceProvidedTypes.getValue()
      .find(type => type.id === typeId);

    if (!assistanceType) {
      return risks;
    }

    return risks.filter(risk => risk.category === assistanceType.category);
  }




  cancel() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveAssistance() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      const assistance: AssistanceProvided = {} as AssistanceProvided;
      Object.assign(assistance, this.assistance);
      assistance.date = +moment(assistance.date).format('X');
      this.dialogValues.assistance = assistance;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  ngOnDestroy() {
    if (this.activitySub) {
      this.activitySub.unsubscribe();
    }
    this.filteredActivities.complete();
  }

}

interface ExtensionActivityTypeDisplay extends ExtensionActivityType {
  categoryName: string;
  categoryIcon: string;
  categoryColor: string;
}
